"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var defaultProps = {
  className: null,
  height: '100%',
  onClick: function onClick() {},
  onHover: function onHover() {},
  kind: 'hollow',
  width: '100%'
};

/** 
* @param {{
*  className?: string;
*  fill?: React.CSSProperties['fill'] | string | CallableFunction;
*  kind?: 'hollow'|'solid';
*  height?: string|number;
*  width?: string|number;
*  onClick?: CallableFunction;
*  onHover?: CallableFunction;
*  [key: string]: any;
* }} props - Component props
*/
function Information(_ref) {
  var className = _ref.className,
    fill = _ref.fill,
    kind = _ref.kind,
    height = _ref.height,
    width = _ref.width,
    onClick = _ref.onClick,
    onHover = _ref.onHover;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onClick: onClick,
    onMouseEnter: onHover,
    onMouseLeave: onHover,
    role: "none"
  }, kind === 'hollow' && /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: height,
    width: width,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Information"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32,64A32,32,0,1,1,64,32,32,32,0,0,1,32,64ZM32,4A28,28,0,1,0,60,32,28,28,0,0,0,32,4Z",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36,50c-3.31,0-6-2.39-6-5.33V29.33A1.81,1.81,0,0,0,28,28a2,2,0,0,1,0-4c3.31,0,6,2.39,6,5.33V44.67A1.81,1.81,0,0,0,36,46,2,2,0,0,1,36,50Z",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "32",
    cy: "17",
    r: "3",
    style: {
      fill: fill
    }
  })), kind === 'solid' && /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Information"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32,0A32,32,0,1,0,64,32,32,32,0,0,0,32,0Zm0,14a3,3,0,1,1-3,3A3,3,0,0,1,32,14Zm4,36c-3.31,0-6-2.39-6-5.33V29.33A1.81,1.81,0,0,0,28,28a2,2,0,0,1,0-4c3.31,0,6,2.39,6,5.33V44.67A1.81,1.81,0,0,0,36,46,2,2,0,0,1,36,50Z",
    style: {
      fill: fill
    }
  })));
}
Information.defaultProps = defaultProps;
var _default = exports.default = Information;